<template>
  <div class="w1200">
      <MediaManager ref="MediaManager" type="game" :date="item?item.created_at:''" :objId="item?item.id:0" :showBtn="false" :uuid="item?item.uuid:''" @onSelect="onSelect"/>

  <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <i class="el-icon-location"></i>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/material' }">素材列表</el-breadcrumb-item>
      <el-breadcrumb-item>编辑素材</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>

<el-form v-if="item" :model="item" :rules="rules" ref="ruleForm" label-width="200px" class="demo-ruleForm">
  <el-form-item label="素材名称" prop="name_cn">
    <el-input v-model="item.name_cn" maxlength="30"></el-input>
  </el-form-item>
  

  

  

  <el-form-item label="素材文件" prop="filename">
    <el-progress
        style="margin-top: 15px;margin-bottom: 20px;"
          v-if="progress>=0"
          :text-inside="true"
          :stroke-width="20"
          :percentage="progress"
        ></el-progress>
    <el-upload v-else
      action
      :accept="accept"
      :before-upload="beforeUpload"
      :show-file-list="false"
      :http-request="upload">
      <el-button size="small" type="primary" :icon="item.filename?'el-icon-box':'el-icon-upload'">{{item.filename?decodeURIComponent(item.filename):'上传文件'}} </el-button>
      <div slot="tip" class="el-upload__tip">
        <span v-if="item.size">文件大小：{{parseInt(item.size * 100)/100}}M - 默认价格：{{item.priceDefault}}</span>
        <span v-else>只能上传rar/zip文件，且不超过3G</span>
          </div>
    </el-upload>

  </el-form-item>

  <el-form-item label="价格" prop="price">
    <el-input type="number" v-model="item.price" :min="1" :max="9999" label="价格">
      <template slot="append">积分</template>
    </el-input>
    <div class="el-upload__tip">
        如果不填，系统会使用默认价格
      </div>

  </el-form-item>


<el-form-item label="标签" prop="tag_id">
  <el-select
          v-model="item.tag_id"
          multiple
          placeholder="请选择素材标签" style="width: 100%">
      <el-option
              v-for="item in tag_list"
              :key="item.id"
              :label="item.name"
              :value="item.id">
      </el-option>
  </el-select>
</el-form-item>








  <el-form-item label="主图" prop="logo">
    <div class="avatar-uploader" @click="choseFile('ico')">
      <el-image class="avatar"
        v-if="item.logo"
        style="width: 150px; height: 150px"
        :src="imgPath+item.logo"
        fit="cover"
      ></el-image>
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </div>
  </el-form-item>

  <el-form-item label="截图" prop="screenshot_ids">
    <el-image
      v-for="item in item.screenshotFiles"
      v-bind:key="item.id"
      style="width: 150px; height: 150px;border-radius:6px; margin-right: 5px;"
      :src="imgPath+item.url"
      fit="cover"
    ></el-image>
    <div class="avatar-uploader el-image" @click="choseFile('screenshot',5)">
      <i class="el-icon-edit avatar-uploader-icon"></i>
    </div>
  </el-form-item>



<el-form-item label="素材介绍" prop="introduction">
    <MyTextEditor ref="myTextEditor" v-model="item.introduction" @imgHandler="imgHandler" :noImg="true"></MyTextEditor>
</el-form-item>
<div v-if="isadmin==1">
  <el-divider content-position="left">管理员功能</el-divider>

    <el-form-item label="视频" prop="videoUrl">
      <el-input v-model="item.videoUrl" label="视频"></el-input>
    </el-form-item>

  <el-form-item label="评分" prop="recommend_c">
    <el-input-number v-model="item.recommend_c" :min="1" :max="10" label="评分"></el-input-number>
  </el-form-item>



  <el-form-item label="状态" prop="state">
    <el-select v-model="item.state" placeholder="请选择状态">
      <el-option :label="-3|state" :value="-3"></el-option>
      <el-option :label="-2|state" :value="-2"></el-option>
      <el-option :label="-1|state" :value="-1"></el-option>
      <el-option :label="0|state" :value="0"></el-option>
      <el-option :label="1|state" :value="1"></el-option>
      <el-option :label="2|state" :value="2"></el-option>
    </el-select>
  </el-form-item>

  <el-form-item label="备注" prop="remark">
    <el-input v-model="item.remark"></el-input>
  </el-form-item>


</div>

<el-form-item >
    <el-button :loading="loading" type="primary" @click="submitForm('ruleForm')">提 交</el-button>
</el-form-item>
</el-form>


  </div>
</template>

<script>
import MediaManager from "@/components/MediaManager_qiniu";
import MyTextEditor from "@/components/MyTextEditor";
import { MyMessage,MyStorage,getOSS } from '@/common.js';

export default {
    components: {
        MediaManager,MyTextEditor,MyStorage
    },
    computed:{
        accept:function(){
            return '.zip,.rar';
        }
    },
    data() {
        return {
          tag_list:[],
            item:{},
          loading:false,
          fileList:[],
            isadmin:MyStorage.getItem('isadmin'),
            imgPath:process.env.VUE_APP_qiniu_baseUrl,
            thumbimg:[],
            progress:-1,
            uploadRes:null,
          rules: {
            name_cn: [
              { required: true, message: "请输入素材名称", trigger: "blur" },
              { min: 2, max: 20, message: "长度在 2 到 30 个字符", trigger: "blur" }
            ],
            introduction: [
              { required: true, message: "请输入介绍", trigger: "blur" },
              { min: 10, max: 3000, message: "长度在 10 到 5000 个字符", trigger: "blur" }
            ],
            logo:[
              { required: true, message: "请上传配图", trigger: "blur" },
            ],
            filename:[
              { required: true, message: "请上传素材文件", trigger: "blur" },
            ]
          }
        }
    },
    mounted() {
        this.loadData(this.$route.params.id);

       
        this.api.tag_list({platform:99},res=>{
          this.tag_list=res.data;
        });
       
    },
    methods:{
        loadData(id) {
            this.loading = true;
            if(id===0){
                this.api.material_add({},res=>{
                    this.item = res.data;
                    if(!this.item.introduction)
                      this.item.introduction='素材介绍：<br><br>  素材特色：<br><br>';
                    this.loading=false;
                })
            }else{
                this.api.material_info(
                    id,
                    res => {
                      this.item = res.data;
                      if(!this.item.introduction)
                        this.item.introduction='素材介绍：<br><br>  素材特色：<br><br>';
                      this.loading = false;
                    }
                );
            }

        },
        choseFile($flag, size = 1) {
            this.$refs.MediaManager.open($flag, size); // 调用子组件的方法open
        },
        onSelect(val) {
            let url = val.files[0].url;
            if (val.target === "ico") {

                this.item.logo = url.replace(this.imgPath,'');
                this.item.logo_id = val.files[0].id;
                this.$forceUpdate();
            } else if (val.target === "screenshot") {
              this.item.screenshotFiles = val.files;
              this.item.screenshot_ids = "";
              this.item.screenshotFiles.forEach(element => {
                element.url=element.url.replace(this.imgPath,'');
                this.item.screenshot_ids += "," + element.id;
              });
              this.item.screenshot_ids = this.item.screenshot_ids.substr(1);
              this.$forceUpdate();
            } else if (val.target === "editor") {
                if (url != null && url.length > 0) {
                    if(this.insertImg) this.insertImg(url)
                } else {
                    MyMessage.error("插入失败");
                }
            }
        },
        beforeClose(){
          if(this.progress>0){
            MyMessage.info('请等待素材文件上传完毕');
            return
          }
            this.$refs['ruleForm'].clearValidate();
            this.$emit('update:visible',false);
        },
        submitForm(formName) {
          if(this.progress>0){
            MyMessage.info('请等待素材文件上传完毕');
            return
          }
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.loading = true;
              this.api.material_edit(
                this.item,
                res => {
                  this.beforeClose()
                  MyMessage.success("保存成功！");
                  this.$router.push("/material");
                },
                err => {
                  this.loading = false;
                }
              );
            } else {
              return false;
            }
          });
        },
        imgHandler(state){
            this.insertImg=state.callback
            if (state.state) {
                this.$refs.MediaManager.open("editor"); // 调用子组件的方法open
            }
        },
        beforeUpload(file){
          if(file.size>1024*1024*1024*2){
            MyMessage.error('文件不能超过2G');
            return false;
          }
        },
        upload(data) {
            let t=this;
            t.loading=true;
            let params={gid:t.item.id,filename:data.file.name};
            t.api.createPresignedRequest(params,res=>{
                 console.log(res);
                 var xhr = new XMLHttpRequest ()
                  xhr.upload.onprogress = e => {
                   t.progress = parseInt(e.loaded / e.total * 100);
                   console.log(e);
                 };
                  xhr.open('PUT', res.data.url, true)
                  xhr.send(data.file)
                  xhr.onload = (res) => {
                    if (xhr.status == 200) {
                        t.progress = -1;

                        t.api.uploadSuccessCallBack(params,
                          res => {
                              t.item.filename=res.data.filename;
                              t.item.size=res.data.size;
                              t.item.priceDefault=res.data.priceDefault;
                              t.item.priceComputed=res.data.priceComputed;
                            MyMessage.success("文件上传成功！");
                            t.loading=false;
                          },
                          err => {
                            MyMessage.success("保存失败！");
                            t.loading = false;
                          }
                        );
                      console.log(res)
                    }
                  }
            },err=>{ console.log(err);})
        }
    }
}
</script>

<style scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
}
.avatar-uploader:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

.quill-editor {
  line-height: 22px;
}
.quill-editor .ql-container {
  min-height: 300px;
}
</style>
